import { SearchResponse, SearchResultType } from '@/api/types';

export function getTableKey(item: SearchResponse | null): string {
  if (item) {
    return item.searchResultType === SearchResultType.trackable
      ? `${item.searchResultType}-${item.fleetNumber}`
      : `${item.searchResultType}-${item.deliveryRunReference}`;
  } else {
    return '';
  }
}
